"use client"

import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon, Loader2Icon } from "lucide-react"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: (
          <CircleCheckIcon className="size-4" />
        ),
        info: (
          <InfoIcon className="size-4" />
        ),
        warning: (
          <TriangleAlertIcon className="size-4" />
        ),
        error: (
          <OctagonXIcon className="size-4" />
        ),
        loading: (
          <Loader2Icon className="size-4 animate-spin" />
        ),
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--success-bg": "oklch(0.18 0.04 143)",
          "--success-text": "var(--success)",
          "--success-border": "oklch(0.869 0.227 143.3 / 0.3)",
          "--error-bg": "oklch(0.18 0.06 8)",
          "--error-text": "var(--destructive)",
          "--error-border": "oklch(0.603 0.199 8.1 / 0.3)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "cn-toast",
          success: "!border-[var(--success-border)] !bg-[var(--success-bg)] !text-[var(--success-text)]",
          error: "!border-[var(--error-border)] !bg-[var(--error-bg)] !text-[var(--error-text)]",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
